import { useTranslation } from 'react-i18next';
import { PostDetailsType } from '@anytag/shared-types';
import { Anchor, SocialIcon } from '@anytag/shared-atoms';
import { cn, getSocialMediaTextLink } from '@anytag/shared-utils';

export interface SocialLinkProps extends Pick<PostDetailsType, 'postUrl' | 'socialMedia'> {
  hasIcon?: boolean;
  className?: string;
}

export const SocialLink = ({ postUrl, socialMedia, className, hasIcon = true }: SocialLinkProps) => {
  const { t } = useTranslation();

  return postUrl && socialMedia ? (
    <div className={cn('flex w-max items-center gap-1', className)}>
      {hasIcon ? <SocialIcon size="16px" type={socialMedia} /> : null}
      <Anchor
        variant="blue"
        target="_blank"
        className="text-sm"
        href={postUrl || '#'}
        label={t('View on', { socialMedia: getSocialMediaTextLink(socialMedia) })}
      />
    </div>
  ) : null;
};
